import type { Asset } from "~/types/asset"

export type VideoProvider = "file" | "youtube" | "vimeo"

const MEDIA_FILE = /\.(mp4|webm|ogg|mov)(\?|$)/i

/**
 * Resolves which player element an asset should be rendered with, so only one
 * player is ever mounted for a given source.
 */
export const getVideoProvider = (
  asset: Asset | null | undefined,
): VideoProvider | null => {
  if (!asset || asset.kind === "image") return null
  if (asset.kind === "video") return "file"

  // kind === "json": an embed URL from adaptVideoEmbedUrl, which passes direct
  // media files through untouched. The extension has to be checked before the
  // host - a progressive .mp4 served from player.vimeo.com is a plain file, not
  // a Vimeo player URL that <vimeo-video> can consume.
  if (MEDIA_FILE.test(asset.url)) return "file"

  let hostname: string
  try {
    hostname = new URL(asset.url).hostname
  } catch {
    return null
  }

  if (/(^|\.)(youtube\.com|youtube-nocookie\.com|youtu\.be)$/.test(hostname)) {
    return "youtube"
  }
  if (/(^|\.)vimeo\.com$/.test(hostname)) return "vimeo"

  return null
}
